import React, {useLayoutEffect} from "react";
import {useAuthDispatcher} from "../context/AuthContext";
import {actionTypes, setLoginStateDispatch} from "../context/reducer";
import {getUserRefreshToken, setUserRefreshToken} from "../service/localStorage/LocalStorageService";
import {LoginService} from "../pages/login/LoginService";


export default function AuthorizationRoute(props) {

    const refreshToken = getUserRefreshToken()
    const dispatch = useAuthDispatcher()
    const service = new LoginService()

    useLayoutEffect(() => {
        if (typeof service !== 'undefined') {
            if (refreshToken !== null) {
                service.getUserTokenByRefreshToken(refreshToken)
                    .then(response => {
                        setUserRefreshToken(response.data.refresh_token)
                        dispatch(setLoginStateDispatch(
                            actionTypes.LOGIN,
                            response.data.access_token))

                    }).catch(reason => {
                    dispatch({
                        type: actionTypes.LOGOUT,
                        loading: false,
                        loginState: false,
                        role: []
                    })
                })
            } else {
                dispatch({
                    type: actionTypes.LOGOUT,
                    loading: false,
                    loginState: false,
                    role: []
                })
            }
        }
    }, [dispatch, refreshToken])

    return (<>{props.children}</>)
}